<template>
  <list-expansion
    v-model="valueComputed"
    :components="customComponents"
    :data="valueComputed"
    @save-required="$emit('save-required')"
    flat
  />
</template>

<script>
import ListExpansion from "../../../content/fragments/listExpansion";

export default {
  name: "qrGenerator",

  components: { ListExpansion },

  props: {
    value: Object,
  },

  provide: {
    provideSingleGallery: true,
  },

  data() {
    return {
      headColor: "#d12229",
      bodyColors: "",
    };
  },

  computed: {
    customComponents() {
      return [
        {
          name: "VideoGallery",
          value: "",
          title: this.$t("add_video"),
          subtitle: "",
          icon: "video-image",
          // model: 'video_single'
        },
        {
          name: "imageUploader",
          value: "",
          title: this.$t("add_image"),
          subtitle: "",
          icon: "cloud-upload-outline",
          model: "photo",
        },
        {
          name: "colorPallete",
          value: "",
          title: this.$t("select_color"),
          subtitle: "",
          icon: "format-color-fill",
          model: "pallete",
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: this.$t("add_social_networks"),
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
        },
      ];
    },
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style scoped></style>
